import { NodeViewWrapper } from '@tiptap/react';

interface MentionComponentProps {
  node: {
    attrs: {
      id: string;
      label: string;
    };
  };
}

export function MentionComponent({ node }: MentionComponentProps) {
  return (
    <NodeViewWrapper className="inline">
      <span
        className="inline-flex items-center text-white rounded-full px-1.5 py-0.5 text-sm font-medium bg-ihs-blue"
        data-mention
        data-id={node.attrs.id}
        data-label={node.attrs.label}
      >
        @{node.attrs.label}
      </span>
    </NodeViewWrapper>
  );
}
